import api from '../api';

export default class EstadosCivisService {
  constructor() {
    throw 'Não é possível instanciar EstadosCivisService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `estados-civis`;
};



// WEBPACK FOOTER //
// ./src/services/enums/estadosCivisService.js